'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _redux = require('redux');

var _refund = require('../actions/refund');

var INITIAL_STATE = {
    isPosting: false,
    isFetching: false,
    items: []
};

var refunds = function refunds() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
    var action = arguments[1];

    switch (action.type) {
        case _refund.POST_REFUND_REQUEST:
            return _extends({}, state, {
                isPosting: true
            });
        case _refund.POST_REFUND_SUCCESS:
            return _extends({}, state, {
                isFetching: false
            });
        case _refund.POST_REFUND_FAILURE:
            return _extends({}, state, {
                isFetching: false,
                error: action.error
            });
        default:
            return state;
    }
};

var refundReducer = (0, _redux.combineReducers)({
    refunds: refunds
});

exports.default = refundReducer;


//////////////////
// WEBPACK FOOTER
// ./src/js/reducers/refund.js
// module id = 909
// module chunks = 0